// extracted by mini-css-extract-plugin
module.exports = {"content":"TheCallsHistory_content_2Ppbk","description":"TheCallsHistory_description_3LnZZ","imgRotate":"TheCallsHistory_imgRotate_aCZSd","text":"TheCallsHistory_text_e0sKg"};